import Action from 'src/redux/action'
import * as actions from 'src/redux/actions/act'

export type ACTState = {
  isRecipientDrawerOpen: boolean
}

const initialState: ACTState = {
  isRecipientDrawerOpen: true,
}

const act = (state: ACTState = initialState, action: Action): ACTState => {
  switch (action.type) {
    case actions.setRecipientDrawerOpen.type:
      return {
        ...state,
        isRecipientDrawerOpen: !state.isRecipientDrawerOpen,
      }
    default:
      return state
  }
}

export default act
